import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useDeviceSize } from '@vmos2/providers';
import type { NutritionType } from 'types';

import { NutritionItem } from './nutritionItem';

type Props = {
  calories: ?number,
  nutrition?: NutritionType,
};

const kJ = 4.184;

const kcalToKj = kcal => kcal * kJ;

const round = (num, precision) => num && num.toFixed(precision);

export const Nutrition = ({ nutrition, calories }: Props) => {
  const { t } = useTranslation('nutrition');
  const { isLargeKioskScreen } = useDeviceSize();
  const { carbs, fats, proteins, carbsSugar, fatSaturates, fibre, salt } = nutrition;

  return (
    <NutritionItemWrapper>
      <NutritionItem name={t('energyKCalTitle')} value={round(calories)} />
      <NutritionItem name={t('energyKJTitle')} value={round(kcalToKj(calories))} />
      <NutritionItem name={t('fatsTitle')} value={round(fats, 1)} units="g" />
      {isLargeKioskScreen && (
        <NutritionItem name={t('saturatedFat')} value={round(fatSaturates, 1)} units="g" fontSize="xs" />
      )}
      <NutritionItem name={t('carbsTitle')} value={round(carbs, 1)} units="g" />
      {!isLargeKioskScreen && (
        <NutritionItem name={t('saturatedFat')} value={round(fatSaturates, 1)} units="g" fontSize="xs" />
      )}
      <NutritionItem name={t('sugarFromCarbs')} value={round(carbsSugar, 1)} units="g" fontSize="xs" />
      <NutritionItem name={t('proteinsTitle')} value={round(proteins, 1)} units="g" />
      <NutritionItem
        name={t('fibresTitle')}
        value={round(fibre, 1)}
        units="g"
        lastNutritionItem={!isLargeKioskScreen}
      />
      <NutritionItem name={t('saltTitle')} value={round(salt, 2)} units="g" lastNutritionItem />
    </NutritionItemWrapper>
  );
};

const NutritionItemWrapper = styled('ul')`
  display: grid;
  column-gap: 24px;
  padding: 0 12px;
  margin: 0;
  grid-template-columns: repeat(2, 1fr);

  @media (${({ theme }) => theme.breakpoint.largeScreenKiosk}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
